import React from 'react';

import { useTranslation } from 'react-i18next';
import { Message } from 'semantic';
import { Link } from 'react-router-dom';

type Props = {
  showLink: boolean;
};

export default function EditEvseControllerChargingPolicyTab({
  showLink = false,
}: Props) {
  const { t } = useTranslation();

  return (
    <>
      <Message success>
        {showLink && (
          <p>
            {t(
              'editEvseControllers.chargingPoliciesTabLinkMessageTextPart',
              'Charging Policies and Tariffs cannot yet be managed in this overview. \nThey can be managed '
            )}
            <Link to="/charging-stations/policies-and-groups/charging-policies">
              {t(
                'editEvseControllers.chargingPoliciesTabLinkMessageLinkPart',
                'in the Policies & Groups section here.'
              )}
            </Link>
          </p>
        )}

        {!showLink && (
          <p>
            {t(
              'editEvseControllers.chargingPoliciesTabNoLinkMessageText',
              'Charging Policies and Tariffs cannot yet be managed in this overview.'
            )}
          </p>
        )}
      </Message>
    </>
  );
}
